if (!customElements.get('slideshow-component')) {
  console.warn('slideshow-component no encontrado');
} else {
  class SlideshowDots extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const slideshowComponent = this.closest('slideshow-component');
      if (!slideshowComponent) return;

      const dots = this.querySelectorAll('.slideshow-controls__dot');
      const scroller = slideshowComponent.querySelector('slideshow-slides');
      
      if (!scroller) return;

      // Click en dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToSlide(index, slideshowComponent, scroller, dots);
        });
      });

      // Observar cambios de scroll para actualizar el dot activo
      let scrollTimeout;
      scroller.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.updateActiveDot(scroller, dots);
        }, 100);
      });
    }

    goToSlide(index, component, scroller, dots) {
      const slides = scroller.querySelectorAll('slideshow-slide');
      if (!slides[index]) return;

      const slideWidth = slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(scroller).gap) || 0;
      const scrollPosition = (slideWidth + gap) * index;

      scroller.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });

      this.updateActiveDot(scroller, dots, index);
    }

    updateActiveDot(scroller, dots, forceIndex = null) {
      const slideWidth = scroller.querySelector('slideshow-slide')?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(scroller).gap) || 0;
      const currentIndex = forceIndex !== null ? forceIndex : Math.round(scroller.scrollLeft / (slideWidth + gap));

      dots.forEach((dot, idx) => {
        dot.classList.toggle('slideshow-controls__dot--active', idx === currentIndex);
        dot.setAttribute('aria-current', idx === currentIndex ? 'true' : 'false');
      });
    }
  }

  customElements.define('slideshow-dots', SlideshowDots);
}
